import authCheckApp from './authCheckApp'

/**
 * 隐藏加载框
 * @since 1.0.0
 * @example
 * 
 * hiddenProgress()
 */
function hiddenProgress() {
    authCheckApp()
        .then(() => {
        // 发起请求
            window.WebViewJavascriptBridge.callHandler('hiddenProgress', {}, (response) => {
                return response
            })
        })
}

export default hiddenProgress